import type { HotZone } from '@/api/types';
import { COMPANY_NAMES } from './CompanyLogo';

const SLOT_LABEL = {
  MORNING: 'утро',
  DAY: 'день',
  EVENING: 'вечер',
  NIGHT: 'ночь',
} as const;

interface Props {
  zone: HotZone;
  rank?: number;
}

export function HotZoneItem({ zone, rank }: Props) {
  return (
    <div className="hot-zone">
      {rank != null && <div className="rank">{rank}</div>}
      <div className="body">
        <div className="district">{zone.district}</div>
        <div className="meta">
          {COMPANY_NAMES[zone.company]} · {SLOT_LABEL[zone.timeSlot]}
        </div>
      </div>
      <div className="eph">{Math.round(zone.medianEphRub)} ₽/час</div>
    </div>
  );
}
